import React from 'react'

const StoreManagerHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4473_29162)" />
    <path
      d="M35.0146 39.3166C36.0223 38.5608 36.9671 37.742 37.9748 36.9862C38.1638 36.8602 38.3527 36.7342 38.4787 36.5453C38.9826 35.9784 39.5494 35.9154 40.2423 36.1674C43.1395 37.0492 45.8478 38.2459 48.1782 40.2613C50.0048 41.8359 51.2015 43.7884 51.6423 46.2448C51.8313 47.3785 51.5164 48.1973 50.5716 48.8272C48.3042 50.3388 45.7848 51.1576 43.1395 51.7244C39.3605 52.4802 35.5185 52.6692 31.6764 52.3543C28.2123 52.1023 24.7482 51.4725 21.536 49.9609C20.9062 49.7089 20.2134 49.331 19.5835 48.9531C18.4498 48.2603 18.1349 47.4415 18.3868 46.1188C18.8907 43.4735 20.4023 41.458 22.4808 39.8205C24.8112 37.9939 27.5195 36.8602 30.3538 36.1044C30.5427 36.0414 30.8576 36.1674 31.0466 36.2934C32.2433 37.2381 33.44 38.1829 34.6367 39.1276C34.7626 39.1276 34.8886 39.2536 35.0146 39.3166ZM35.0776 39.5685C35.0146 39.5685 35.0146 39.5685 34.9516 39.5685C34.4477 41.584 33.9439 43.5365 33.377 45.552C33.1251 46.4968 33.188 47.1896 33.7549 47.9454C34.1958 48.5752 34.5737 49.2051 35.0146 49.9609C35.7074 48.8901 35.6444 49.0791 36.1483 48.0084C36.4632 47.4415 37.0931 46.7487 36.6522 45.3001C36.2743 43.9144 36.2113 43.7255 35.8334 42.3398C35.5814 41.458 35.3295 40.5133 35.0776 39.5685Z"
      fill="white"
    />
    <path
      d="M35.0775 35.0966C31.9283 34.9707 29.5349 33.585 27.9603 30.9397C25.8189 27.4756 26.3857 22.8148 29.283 19.9175C32.5582 16.6423 37.7228 16.7053 40.935 20.0435C45.3439 24.6413 43.6433 32.4513 37.7228 34.5928C37.3449 34.7187 36.967 34.8447 36.5261 34.9077C36.0223 35.0337 35.5184 35.0337 35.0775 35.0966Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4473_29162"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default StoreManagerHome
